import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./ServiceList.module.css";
import { ReactComponent as ArrowRightIcon } from "../assets/icons/arrowRight.svg";
import { ReactComponent as PolygonIcon } from "../assets/icons/Polygon.svg";
import { useDispatch } from "react-redux"; 
import { setActiveTab } from "../store/tabSlice"; 

interface Service {
  id: number;
  name: string;
  logo: string;
}

const ServiceCard: React.FC<{ service: Service }> = React.memo(({ service }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const partners = JSON.parse(localStorage.getItem("partners") || "[]");

  // پیدا کردن آرایشگرهایی که این سرویس رو دارن
  const servicePartners = partners.filter((partner: any) =>
    partner.categories?.includes(service.id)
  );

  const partnerNames = servicePartners.map((partner: any) => `${partner.firstname} ${partner.lastname}`);

  const handleReserveClick = () => {
    dispatch(setActiveTab("appointments")); 
    navigate(`/times?service=${service.id}`); 
  };

  return (
    <div className={styles.serviceCard}>
      <div className={styles.serviceRow}>
        <div className={styles.serviceInfo}>
          <div className={styles.serviceHeader}>
            <h6 className={styles.serviceName}>{service.name || "نامشخص"}</h6>
            <PolygonIcon className={styles.servicePolygonIcon} />
          </div>
          <p className={styles.serviceDetails}>
            {partnerNames.length > 0
              ? `آرایشگرها: ${partnerNames.join(", ")}`
              : "هیچ آرایشگری این سرویس را ارائه نمی‌دهد"}
          </p>
        </div>

        <div className={styles.serviceIconContainer}>
          <img
            src={service.logo}
            alt={service.name || "بدون نام"}
            className={styles.serviceIcon}
          />
        </div>
      </div>

      <div className={styles.reserveButtonContainer}>
        <button className={styles.reserveButton} onClick={handleReserveClick}>
          <ArrowRightIcon className={styles.reserveArrowIcon} />
          <span>رزرو نوبت</span>
        </button>
      </div>
    </div>
  );
});

export default ServiceCard;
